"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDayName = exports.getMonthName = exports.isDateAfter = exports.isDateBefore = exports.isSameDate = exports.getNextDisplayYear = exports.getPreviousDisplayYear = exports.getNextMonth = exports.getPreviousMonth = exports.getWeeks = exports.addDay = exports.addDays = exports.DAYS_OF_WEEK = void 0;
exports.DAYS_OF_WEEK = [0, 1, 2, 3, 4, 5, 6];
var DAYS_PER_WEEK = 7;
var WEEKS_PER_MONTH = 6;
var addDays = function (date, days) {
    var newDate = new Date(date);
    newDate.setDate(date.getDate() + days);
    return newDate;
};
exports.addDays = addDays;
var addDay = function (date) { return (0, exports.addDays)(date, 1); };
exports.addDay = addDay;
var getWeeks = function (month, year) {
    var firstOfMonth = new Date(year, month, 1);
    var weekMatrix = new Array(WEEKS_PER_MONTH).fill(new Array(DAYS_PER_WEEK).fill(null));
    var currentDate = firstOfMonth;
    var weeks = weekMatrix.map(function (week, weekIndex) { return (week.map(function (_, dayIndex) {
        var index = dayIndex + (weekIndex * DAYS_PER_WEEK);
        if (index < firstOfMonth.getDay()) {
            var offsetDays = (firstOfMonth.getDay() - index) * -1;
            return (0, exports.addDays)(firstOfMonth, offsetDays);
        }
        if (index === firstOfMonth.getDay()) {
            return firstOfMonth;
        }
        currentDate = (0, exports.addDay)(currentDate);
        return currentDate;
    })); });
    // Some months have 6 weeks, some have 5. If the last week is not part of the current month, remove it.
    var firstDayOfLastWeek = weeks[weeks.length - 1][0];
    if (firstDayOfLastWeek.getMonth() !== month) {
        weeks.pop();
    }
    return weeks;
};
exports.getWeeks = getWeeks;
var getPreviousMonth = function (month) {
    if (month === 0) {
        return 11;
    }
    return month - 1;
};
exports.getPreviousMonth = getPreviousMonth;
var getNextMonth = function (month) {
    if (month === 11) {
        return 0;
    }
    return month + 1;
};
exports.getNextMonth = getNextMonth;
var getPreviousDisplayYear = function (month, year) {
    if (month === 0) {
        return year - 1;
    }
    return year;
};
exports.getPreviousDisplayYear = getPreviousDisplayYear;
var getNextDisplayYear = function (month, year) {
    if (month === 11) {
        return year + 1;
    }
    return year;
};
exports.getNextDisplayYear = getNextDisplayYear;
var isSameDate = function (date1, date2) { return (date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()); };
exports.isSameDate = isSameDate;
var isDateBefore = function (date, comparisonDate) { return (date.getTime() < comparisonDate.getTime()); };
exports.isDateBefore = isDateBefore;
var isDateAfter = function (date, comparisonDate) { return (date.getTime() > comparisonDate.getTime()); };
exports.isDateAfter = isDateAfter;
var getMonthName = function (month) {
    switch (month) {
        case 0:
            return 'January';
        case 1:
            return 'February';
        case 2:
            return 'March';
        case 3:
            return 'April';
        case 4:
            return 'May';
        case 5:
            return 'June';
        case 6:
            return 'July';
        case 7:
            return 'August';
        case 8:
            return 'September';
        case 9:
            return 'October';
        case 10:
            return 'November';
        case 11:
            return 'December';
        default:
            return '';
    }
};
exports.getMonthName = getMonthName;
var getDayName = function (day) {
    switch (day) {
        case 0:
            return 'Su';
        case 1:
            return 'M';
        case 2:
            return 'Tu';
        case 3:
            return 'W';
        case 4:
            return 'Th';
        case 5:
            return 'F';
        case 6:
            return 'Sa';
        default:
            return '';
    }
};
exports.getDayName = getDayName;
